"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9936],{

/***/ 60996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ map_card; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(89136);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(46572);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/atoms/see-more/index.ts + 1 modules
var see_more = __webpack_require__(97932);
// EXTERNAL MODULE: ./components/atoms/icon/index.ts + 2 modules
var icon = __webpack_require__(64903);
// EXTERNAL MODULE: ./components/atoms/link/index.ts + 1 modules
var atoms_link = __webpack_require__(27594);
// EXTERNAL MODULE: ./components/molecules/card/index.ts + 1 modules
var card = __webpack_require__(25649);
;// CONCATENATED MODULE: ./components/organisms/map-card/MapCard.tsx





/**
 * MapCard
 */ var MapCard = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, caption = param.caption, servicios = param.servicios, transporte = param.transporte, itemsToShow = param.itemsToShow, subtitle = param.subtitle, title = param.title, orientation = param.orientation, mapIframe = param.mapIframe, numberOfElements = param.numberOfElements, button = param.button;
    var t = (0,useTranslation/* default */.Z)("common").t;
    var itemsList = itemsToShow === "transporte" ? transporte : servicios;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* default */.Z, {
        multimediaProps: {
            src: mapIframe,
            popUp: true,
            descPopUp: subtitle,
            popUpTitle: title
        },
        orientation: orientation,
        className: "bg-white  ".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col justify-around ".concat(!(button === null || button === void 0 ? void 0 : button.src) && !(button === null || button === void 0 ? void 0 : button.label) ? "min-h-[274px]" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-1 text-primary-400",
                        children: [
                            caption && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-caption text-caption--small",
                                children: caption
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "text-heading text-heading--h3",
                                children: title
                            }),
                            subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-body text-body--secondary font-bold",
                                children: subtitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-2 mt-8 text-primary-400\n          ".concat(orientation === "column" ? "flex flex-col" : "grid grid-cols-2 gap-4 "),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(see_more/* default */.Z, {
                            labels: {
                                viewLess: t("components.atoms.seeMore.labels.viewLess"),
                                viewMore: t("components.atoms.seeMore.labels.viewMore")
                            },
                            icon: "ArrowDownPri",
                            expanded: false,
                            variant: "primary",
                            numberOfElements: numberOfElements,
                            children: itemsList.map(function(element, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-row items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                            className: "text-primary-400",
                                            height: 16,
                                            width: 16,
                                            src: element.icon
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-body text-body--secondary ",
                                            children: element.text
                                        })
                                    ]
                                }, index);
                            })
                        })
                    })
                ]
            }),
            (button === null || button === void 0 ? void 0 : button.label) && (button === null || button === void 0 ? void 0 : button.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pt-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: button === null || button === void 0 ? void 0 : button.src,
                    passHref: true,
                    prefetch: false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* default */.Z, {
                        arrow: true,
                        as: "span",
                        variant: button === null || button === void 0 ? void 0 : button.variant,
                        className: "flex w-full items-center justify-center",
                        children: button === null || button === void 0 ? void 0 : button.label
                    })
                })
            })
        ]
    });
};
MapCard.displayName = "MapCard";

;// CONCATENATED MODULE: ./components/organisms/map-card/index.ts

/* harmony default export */ var map_card = (MapCard);


/***/ }),

/***/ 89936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ map_template; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(43291);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./components/atoms/container/index.ts + 1 modules
var container = __webpack_require__(82112);
// EXTERNAL MODULE: ./components/atoms/section-text/index.ts
var section_text = __webpack_require__(67526);
// EXTERNAL MODULE: ./components/organisms/map-card/index.ts + 1 modules
var map_card = __webpack_require__(60996);
;// CONCATENATED MODULE: ./components/templates/map-template/MapTemplate.tsx




/**
 * MapTemplate
 */ var MapTemplate = function(param) {
    var backgroundColorBottom = param.backgroundColorBottom, backgroundColorTop = param.backgroundColorTop, caption = param.caption, desc = param.desc, mapCard = param.mapCard, textColor = param.textColor, title = param.title, backgroundColorBottomMobile = param.backgroundColorBottomMobile, backgroundColorTopMobile = param.backgroundColorTopMobile, nivelCorteDesk = param.nivelCorteDesk, nivelCorteMobile = param.nivelCorteMobile, hasCutLevel = param.hasCutLevel, index = param.index, id = param.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
        id: id,
        index: index,
        hasCutLevel: hasCutLevel,
        cutLevel: nivelCorteDesk !== null && nivelCorteDesk !== void 0 ? nivelCorteDesk : 50,
        cutLevelMobile: nivelCorteMobile !== null && nivelCorteMobile !== void 0 ? nivelCorteMobile : 50,
        backgroundColorTop: backgroundColorTop,
        backgroundColorBottom: backgroundColorBottom,
        backgroundColorBottomMobile: backgroundColorBottomMobile,
        backgroundColorTopMobile: backgroundColorTopMobile,
        className: "flex flex-col gap-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(section_text/* default */.Z, {
                textAlign: "start",
                direction: "row",
                variant: textColor,
                title: title,
                caption: caption,
                desc: desc
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(map_card/* default */.Z, (0,_object_spread/* default */.Z)({}, mapCard))
        ]
    });
};
MapTemplate.displayName = "MapTemplate";

;// CONCATENATED MODULE: ./components/templates/map-template/index.ts

/* harmony default export */ var map_template = (MapTemplate);


/***/ })

}]);